import { render, staticRenderFns } from "./LayoutsSidebar.vue?vue&type=template&id=00c9daee&scoped=true"
import script from "./LayoutsSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutsSidebar.vue?vue&type=script&lang=js"
import style0 from "./LayoutsSidebar.vue?vue&type=style&index=0&id=00c9daee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c9daee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c9daee')) {
      api.createRecord('00c9daee', component.options)
    } else {
      api.reload('00c9daee', component.options)
    }
    module.hot.accept("./LayoutsSidebar.vue?vue&type=template&id=00c9daee&scoped=true", function () {
      api.rerender('00c9daee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutsSidebar.vue"
export default component.exports